module.exports = __webpack_public_path__ + "img/29.1ebe57dd.svg";